import { ReactComponent } from "./refresh-line.svg";

const RefreshLineIcon = () => <ReactComponent />;

export default RefreshLineIcon;
